(function () {
  if (window.BKCollectionTabDeferredLoaded) return;
  window.BKCollectionTabDeferredLoaded = true;

  const panelCache = new Map();
  const parser = new DOMParser();

  function getPanel(root, id) {
    return Array.from(root.querySelectorAll(".bls__cls-tab")).find(
      (panel) => panel.id === id
    );
  }

  function setAccessibility(root, activeId) {
    root.querySelectorAll(".bls__collection-tab-item").forEach((tab) => {
      const isActive = tab.dataset.id === activeId;
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    root.querySelectorAll(".bls__cls-tab").forEach((panel) => {
      panel.setAttribute("aria-hidden", panel.id === activeId ? "false" : "true");
    });
  }

  function buildPanelUrl(panel) {
    const url = new URL(window.location.href);
    url.searchParams.set("section_id", panel.dataset.bkSectionId);
    url.searchParams.set("bk_collection_tab_partial", "1");
    url.searchParams.set("bk_collection_tab_block", panel.dataset.bkTabBlockId);
    return url.toString();
  }

  function initializeProductMarkup(panel) {
    panel.querySelectorAll(".bls__swiper").forEach((swiper) => {
      try {
        window.BlsSettingsSwiper?.BlsCarousel?.(swiper);
      } catch (error) {
        console.warn("Collection tab carousel init failed", error);
      }
    });

    [
      "BlsColorSwatchesShopify",
      "BlsSubActionProduct",
      "BlsReloadSpr",
      "BlsLazyloadImg",
    ].forEach((name) => {
      try {
        window[name]?.init?.();
      } catch (error) {
        console.warn(`${name} init failed`, error);
      }
    });
  }

  function setStatus(panel, message, retry) {
    panel.innerHTML = "";
    const status = document.createElement("div");
    status.className = "bls__deferred-tab-status text-center mt-30 mb-30";
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.textContent = message;

    if (retry) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "btn-primary mt-15";
      button.textContent = "Bandyti dar kartą";
      button.addEventListener("click", () => loadPanel(panel, true));
      status.appendChild(document.createElement("br"));
      status.appendChild(button);
    }

    panel.appendChild(status);
  }

  async function loadPanel(panel, forceReload) {
    if (!panel) return;
    if (panel.dataset.bkTabLoaded === "true") {
      initializeProductMarkup(panel);
      return;
    }
    const cacheKey = `${panel.dataset.bkSectionId}:${panel.dataset.bkTabBlockId}`;

    if (!forceReload && panelCache.has(cacheKey)) {
      panel.innerHTML = panelCache.get(cacheKey);
      panel.dataset.bkTabLoaded = "true";
      initializeProductMarkup(panel);
      return;
    }

    panel.dataset.bkTabLoading = "true";
    setStatus(panel, "Kraunama...", false);

    try {
      const response = await fetch(buildPanelUrl(panel), {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!response.ok) {
        throw new Error(`Tab request failed: ${response.status}`);
      }

      const html = await response.text();
      const doc = parser.parseFromString(html, "text/html");
      const remotePanel = doc.querySelector(
        `[data-bk-tab-block-id="${panel.dataset.bkTabBlockId}"]`
      );
      const renderedSection = doc.querySelector(
        `#shopify-section-${panel.dataset.bkSectionId}`
      );
      const markup = (
        remotePanel?.innerHTML ||
        renderedSection?.innerHTML ||
        html
      ).trim();

      if (!markup) {
        throw new Error("Empty tab response");
      }

      panelCache.set(cacheKey, markup);
      panel.innerHTML = markup;
      panel.dataset.bkTabLoaded = "true";
      initializeProductMarkup(panel);
    } catch (error) {
      console.warn("Collection tab load failed", error);
      panel.dataset.bkTabLoaded = "false";
      setStatus(panel, "Nepavyko įkelti.", true);
    } finally {
      panel.dataset.bkTabLoading = "false";
    }
  }

  function loadForTab(tab) {
    const root = tab.closest(".bls__collection-tab");
    if (!root || !tab.dataset.id) return;

    setAccessibility(root, tab.dataset.id);
    loadPanel(getPanel(root, tab.dataset.id), false);
  }

  document.addEventListener("click", (event) => {
    const tab = event.target.closest(".bls__collection-tab-item[data-id]");
    if (tab) loadForTab(tab);
  });

  document.addEventListener("keydown", (event) => {
    const tab = event.target.closest(".bls__collection-tab-item[data-id]");
    if (!tab) return;

    const root = tab.closest(".bls__collection-tab");
    const tabs = Array.from(root.querySelectorAll(".bls__collection-tab-item[data-id]"));
    const current = tabs.indexOf(tab);
    let next = current;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      tab.click();
      return;
    }

    if (event.key === "ArrowRight") next = (current + 1) % tabs.length;
    if (event.key === "ArrowLeft") next = (current - 1 + tabs.length) % tabs.length;

    if (next !== current) {
      event.preventDefault();
      tabs[next].focus();
      tabs[next].click();
    }
  });

  document.addEventListener("change", (event) => {
    const select = event.target.closest(".select-data");
    if (!select) return;

    const root = select.closest(".bls__collection-tab");
    if (!root) return;

    const panel = getPanel(root, select.value);
    setAccessibility(root, select.value);
    if (panel) loadPanel(panel, false);
  });
})();
